import React from 'react'

function Description() {
    return (
                <div>
            <div id="description" className="basic-2">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h2>What Will You Learn In Our Data Analytical and Machine Learning Workshops</h2>
                        </div> 
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <ul className="list-unstyled li-space-lg first">
                                <li className="media">
                                    <i className="bullet">1</i>
                                    <div className="media-body">
                                        <h4>Efficient Handling of Data</h4>
                                        <p>Machine Learning can be multidimensional or different types of data. It can process and analyze these data that normal systems can’t. Data is the most important part of any Machine Learning model. Also, studying and handling of data is a field in itself.</p>
                                    </div>
                                </li>
                                <li className="media">
                                    <i className="bullet">2</i>
                                    <div className="media-body">
                                        <h4>Wide Range of Applications</h4>
                                        <p>ML has a wide variety of applications. This means that we can apply ML on any of the major fields. ML has its role everywhere from medical, business, banking to science and tech. This helps to create more opportunities. It plays a major role in customer interactions.</p>
                                    </div>
                                </li>
                                
                            </ul>
                        </div> 
                        <div className="col-lg-6">
                            <ul className="list-unstyled li-space-lg second">
                                <li className="media">
                                    <i className="bullet">3</i>
                                    <div className="media-body">
                                        <h4>Automation of Everything</h4>
                                        <p>Machine Learning is responsible for cutting the workload and time. By automating things we let the algorithm do the hard work for us. Automation is now being done almost everywhere. The reason is that it is very reliable. Also, it helps us to think more creatively.</p>
                                    </div>
                                </li>
                                <li className="media">
                                    <i className="bullet">4</i>
                                    <div className="media-body">
                                        <h4>Use in E-Commerce and Education</h4>
                                        <p>Recently in China, a school has started to use ML to improve student focus. In online shopping, the ML model studies your searches. Based on your search history, it would provide advertisements. These will be about your search preferences in previous searches. In this, the search history is the data for the model. This is a great way to improve e-commerce with ML.</p>
                                    </div>
                                </li>
                                
                            </ul>
                        </div> 
                    </div> 
                </div> 
            </div> 

        </div>
    )
}

export default Description
